import { render, staticRenderFns } from "./BlwUploadV2.vue?vue&type=template&id=27c1e1a3&"
import script from "./BlwUploadV2.vue?vue&type=script&lang=js&"
export * from "./BlwUploadV2.vue?vue&type=script&lang=js&"
import style0 from "./BlwUploadV2.vue?vue&type=style&index=0&id=27c1e1a3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports